import React, { useContext, useEffect } from 'react';
import { Link } from 'gatsby';

import Layout from '../components/layout';
import GeneralAnchor from '../components/general-anchor/general-anchor.component';
import CalculatorBox from '../components/calculator-box/calculator-box.component';

import { MenuContext } from '../context';
import NewWindow from '../assets/new_window.inline.svg';

import '../styles/app.scss';
import {triggerTealiumEvent} from "../utils/tealiumUtils";
import {useLocation} from "@reach/router";

const BROKER_S_LINKS = [
  {
    title: "Contact us",
    href: "/broker-support",
  },
  {
    title: "Frequently asked questions",
    href: "/frequently-asked-questions",
    isLink: false,
  },
];

const PLEASE_READ_LINKS = [
  {
    title: "Criteria",
    href: "/criteria",
  },
  {
    title: "Latest news",
    href: "/newsroom",
  },
];

export default function AffordabilityCalculator() {
  const menuContext = useContext(MenuContext);
  const location = useLocation();

  if (typeof window !== "undefined" && window.utag) {
    triggerTealiumEvent({
      tealiumEvent: "view",
      pageUrl: location.href,
      pageName: "calculator",
      pageType: "product information",
      pageSubCategory: "calculator",
      rawDataLayer: "10451v17",
    });
  }

  return (
    <Layout
      title="Affordability calculator"
      metaDescription="This quick and easy to use Affordability Calculator will provide an indication of how much HSBC UK could lend your customer(s). Please refer to our Residential Lending Criteria for further information."
    >
      <section className="calculator-page page-section row">
        <div className="col-xs-12 col-lg-7">
          <h1 className="page-title">Calculators</h1>
          <div className="row">
            <div className="col-xs-12 col-lg-6 calculator-column">
              <h2 className="h3">Residential calculator</h2>
              <p>
                The Residential calculator will provide an indication of how much HSBC UK could lend to your customer(s), the returned result does not constitute an offer to lend.<br />
              </p>
              <p>
                For further information on our policies, refer to our{" "}
                <Link
                  className="inline-link"
                  to="/criteria/?tab=residential"
                  inert={menuContext.isMenuOpen ? "true" : null}
                >
                  Residential Criteria
                </Link>{" "}
                page.
              </p>
              <GeneralAnchor
                href="https://www.hsbc.co.uk/services/global-mortgages/ntb/affordability-calculator/"
                isBlank
                isRed
                isLink={true}
              >
                Launch Residential calculator
                <NewWindow />
              </GeneralAnchor>
            </div>
            <div className="col-xs-12 col-lg-6 calculator-column">
              <h2 className="h3">Buy to let calculator</h2>
              <p>
                The Buy to let calculator will provide an indication of whether HSBC UK could lend based on the expected
                rental income. For further information on our policies, refer to our{" "}
                <Link
                  className="inline-link"
                  to="/criteria/?tab=buy-to-let"
                  inert={menuContext.isMenuOpen ? "true" : null}
                >
                  Buy to let Criteria
                </Link>{" "}
                page.
              </p>
              <GeneralAnchor
                href="https://www.hsbc.co.uk/services/global-mortgages/ntb/btl-calculator/"
                isBlank
                isRed
                isLink={true}
              >
                Launch Buy to let calculator
                <NewWindow />
              </GeneralAnchor>
            </div>
          </div>
          <p>
            Please complete a Decision in Principle (DIP) to receive an indication of the maximum amount HSBC UK may be able to lend. This amount could change following our receipt of a satisfactory valuation, and once a full assessment of the mortgage application has been completed by our underwriters.
          </p>
          <div className="row">
            <div className="col-xs-12 col-lg-6 calculator-column calculator-column--default">
              <h2 className="h3">Repayment calculator</h2>
              <p className='mb-20 short-paragraph'>
                Work out how much your monthly repayments could be
              </p>
              <GeneralAnchor
                href="https://www.hsbc.co.uk/mortgages/repayment-calculator/"
                isBlank
                isRed
                isLink={true}
              >
                Launch Repayment calculator
                <NewWindow />
              </GeneralAnchor>
            </div>
            <div className="col-xs-12 col-lg-6 calculator-column calculator-column--default">
              <h2 className="h3">Overpayment calculator</h2>
              <p className='mb-20'>
                See how overpaying your mortgage could reduce the term and overall interest paid
              </p>
              <GeneralAnchor
                href="https://www.hsbc.co.uk/mortgages/mortgage-overpayment-calculator/"
                isBlank
                isRed
                isLink={true}
              >
                Launch Overpayment calculator
                <NewWindow />
              </GeneralAnchor>
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-lg-4 col-lg-offset-1">
          <CalculatorBox title="Broker support" links={BROKER_S_LINKS} />
          <CalculatorBox title="Please read" links={PLEASE_READ_LINKS} color="#00847F" />
        </div>
      </section>
    </Layout>
  );
}
